import angular from "angular";

import CoverageModuleRouting from "./coverage.module.routing";

export default angular
    .module("vt-coverage", [])
    .config(CoverageModuleRouting);
